export function getButtonIconSize(size) {
    switch (size) {
        case 'xlarge':
            return 'large';
        case 'large':
            return 'medium';
        case 'small':
        case 'medium':
            return 'small';
        case 'xsmall':
            return 'xsmall';
        default:
            return 'inherit';
    }
}
